<template>
<main class="home">
  <section id="intro">
    <div v-html="home.text"></div><br>
  </section>
  <info />
  <testimonials />
  <programm />
  <section id="tickets" v-if="tickets.visible">
    <h1>Tickets</h1>
    <div class="aha-tickets">
      <a :href="tickets.tickets" target="_blank" v-html="tickets.tickettxt">
      </a>
    </div>
  </section>
  <podcast />
  <newsletter />
  <curators />
  <question />
  <partners />
  <kontakt />
</main>
</template>

<script>
import Question from '../components/Question.vue'
import Programm from './Programm.vue'
import Info from './Info.vue'
import Testimonials from './Testimonials.vue'
import Curators from './Kuratorium.vue'
import Partners from './Partners.vue'
import Kontakt from './Kontakt.vue'
import Newsletter from '../components/Newsletter.vue'
import Podcast from '../components/Podcast.vue'

export default {
  name: 'home',
  components: {
    Question,
    Programm,
    Info,
    Testimonials,
    Curators,
    Partners,
    Kontakt,
    Newsletter,
    Podcast
  },
  computed: {
    home() {
      return this.$store.getters.getPageByUID('home')
    },
    tickets() {
      return this.$store.getters.getPageByUID('tickets')
    }
  },
}
</script>

<style lang="scss">
@import '../assets/styles/base';
</style>
